<template>
  <div id="modalMallLabels" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <modal-loading :show="loading"></modal-loading>
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("mall.复制商品到其他标签") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-x-25 pd-y-10">
          <form>
            <div class="form-group row mg-b-10">
              <p class="col-12 mg-b-0">{{ $t("mall.选择要加入的标签") }}:</p>
            </div>
            <div class="form-group row mg-b-10">
              <div
                class="col-12"
                v-for="(item, index) in group_list"
                :key="index"
              >
                <label class="c-checkbox-wrap">
                  <input type="radio" :value="item.id" v-model="checkedArr" />
                  <div class="c-checkbox">
                    <i class="ion-android-checkbox-blank"></i>
                    <span style="word-break: break-all">{{ item.name }}</span>
                  </div>
                </label>
                <div
                  class="col-12"
                  v-if="item.chlidren && item.chlidren.length > 0"
                >
                  <label
                    v-for="(stock, stockIndex) in item.chlidren"
                    :key="stockIndex"
                    class="c-checkbox-wrap"
                  >
                    <input
                      type="radio"
                      :value="stock.id"
                      v-model="checkedArr"
                    />
                    <div class="c-checkbox">
                      <i class="ion-android-checkbox-blank"></i>
                      <span style="word-break: break-all">{{
                        stock.name
                      }}</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-primary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            @click="saveMallLabel()"
          >
            {{ $t("mall.保存") }}
          </button>
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("mall.取消") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open", "group_list"],
  data() {
    return {
      checkedArr: "",
      loading: false,
    };
  },
  watch: {
    open: function () {
      this.checkedArr = [];
    },
  },
  computed: {},
  components: {},
  filters: {},
  methods: {
    saveMallLabel() {
      this.$emit("saveMallLabel", this.checkedArr);
    },
  },
};
</script>

